'use client';

import Image from 'next/image';
import { TooltipedElem } from '../TooltipedElem';

type Props = {
  tooltipText: string;
  value: string;
};

export const LockedField: React.FC<Props> = ({ value, tooltipText }) => {
  return (
    <div className='h-[50px] flex gap-[8px] items-center w-full'>
      <span className='text-m '>{value}</span>

      <TooltipedElem tooltipText={tooltipText} showOnHover={true} duration={0}>
        <Image src='/assets/icons/lock.svg' width={24} height={24} alt='' className='cursor-pointer' />
      </TooltipedElem>
    </div>
  );
};
